import { kwiffCookieAcceptanceKey } from '../data-types/cookies/cookiesConstants';
import { countriesWithoutCookies } from '../data-types/international/internationalConstants';
import { setChatCookieDialog, setCookieSnackbar } from '../state/actions/dialogActions';
import { store } from '../state/store';

export const hasAcceptedCookies = () => localStorage.getItem(kwiffCookieAcceptanceKey);

const cookiesConsentNotRequiredInLocation = (location: string | undefined) =>
  location && (countriesWithoutCookies as string[]).includes(location);

export const cookiesConsentNotRequired = () => {
  const {
    userData: { geoLocation },
  } = store.getState();

  return cookiesConsentNotRequiredInLocation(geoLocation);
};

export const alreadyAllowsCookies = () => hasAcceptedCookies() || cookiesConsentNotRequired();

export const closeCookieDialog = (accept: boolean) => {
  if (accept) {
    localStorage.setItem(kwiffCookieAcceptanceKey, '1');
  }
  setCookieSnackbar(false);
  setChatCookieDialog(false);
};
